import { DSCardWrapper } from "@components/design-system/molecules";
import { faStar as faStarEmpty } from "@fortawesome/pro-regular-svg-icons";
import {
  faStar,
  faShareFromSquare,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "@hooks";
import { useDisplayName } from "@hooks/use-display-name";
import moment from "moment";
import { useState } from "react";

import ShareTemplateModal from "./ShareTemplateModal";

export default function TemplateListItem({
  template,
  onClick,
  onFavouriteToggle,
  icon,
  dataTestId,
  refetch,
}) {
  const { userUuid } = useAuth();
  const [shouldShowShareModal, setShouldShowShareModal] =
    useState(false);

  const isOwnedByCurrentUser = template?.user?.uuid === userUuid;

  const handleStarClick = (e) => {
    e.stopPropagation(); // Prevent triggering the parent onClick
    e.preventDefault(); // Prevent triggering two alerts
    onFavouriteToggle(template.uuid);
  };
  const handleShareClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShouldShowShareModal(true);
  };

  const handleShare = () => {
    setShouldShowShareModal(false);
  };

  const ownerDisplayName = useDisplayName(template.user, {
    includeLastName: true,
  });

  return (
    <>
      <DSCardWrapper
        interactive={true}
        variant="default"
        padding="p-md"
        onClick={onClick}
        dataTestId={dataTestId}
      >
        <div
          className="flex flex-row gap-sm items-center w-full"
          key={template.uuid}
        >
          <FontAwesomeIcon
            icon={icon}
            size="2x"
            className="text-brand mt-1"
          />
          <div className="flex flex-col w-full min-w-px">
            <div className="flex flex-row items-center mb-1">
              <span className="text-sm font-medium truncate flex-1 min-w-0">
                {template.name}
              </span>
              {template.templateType !== "SCRIBENOTE_DEFAULT" && (
                <div className="flex items-center ml-2 shrink-0">
                  {isOwnedByCurrentUser && (
                    <FontAwesomeIcon
                      icon={faShareFromSquare}
                      className="text-brand hover:opacity-80 transition-colors mr-1"
                      onClick={handleShareClick}
                      data-testid="share-template-button"
                    />
                  )}
                  <label
                    className={
                      "cursor-pointer text-yellow-500 hover:text-yellow-600"
                    }
                    onClick={handleStarClick}
                    data-testid="favorite-star"
                  >
                    <input
                      type="checkbox"
                      className="sr-only"
                      checked={template.isFavourite}
                      onChange={() => {}} // Required to avoid React warning
                    />
                    <FontAwesomeIcon
                      icon={
                        template.isFavourite ? faStar : faStarEmpty
                      }
                    />
                  </label>
                </div>
              )}
            </div>
            <p className="text-xs w-full line-clamp-2">
              {template.description}
            </p>

            <div className="flex flex-row items-center justify-between">
              {template.createdAt && (
                <div className="mt-1 text-secondary text-xs">
                  {moment(template.createdAt).format("MMM DD, YYYY")}
                </div>
              )}

              {template?.user && (
                <div className="text-xs text-secondary">
                  {ownerDisplayName}
                </div>
              )}
            </div>
          </div>
        </div>
      </DSCardWrapper>

      <ShareTemplateModal
        shouldShow={shouldShowShareModal}
        hideModal={() => setShouldShowShareModal(false)}
        template={template}
        onShare={handleShare}
        refetch={refetch}
        source="templates dashboard"
      />
    </>
  );
}
